export default __webpack_public_path__ + "static/media/settings.a3b0bcb5.svg";